import React, { Component } from 'react';
import PhotoModal from '../pieces/PhotoModal';
import Placeholder from '../pieces/Placeholder';
import { ROOT_DIR } from '../../utils/Constants';
import GeneralUtils from '../../utils/GeneralUtils';
import LazyLoad from 'react-lazyload';


class Photos extends Component {
  state = {
    selectedPhoto: {},
    viewPhoto: false,
    currNum: 0
  }
  componentDidMount(){
    this.props.getPhotos();

  }
  
  nextPhoto = (e) => {
    e.preventDefault();
    let num = parseInt(this.state.selectedPhoto.id,10) + 1;
    let paddedNum = GeneralUtils.pad(num,4);
    this.selectPhoto(paddedNum);
  }
  prevPhoto = (e) => {
    e.preventDefault();
    let num = parseInt(this.state.selectedPhoto.id,10) - 1;
    let paddedNum = GeneralUtils.pad(num,4);
    this.selectPhoto(paddedNum);
  }
  handleClose = (e) => {
    e.preventDefault();
    this.setState({
      viewPhoto: false
    })
  }
  selectPhoto = (id) => {
    let obj = {};
    for (let value of this.props.photos){
      if(id === value.id){
        obj = value;
      }
    }
    this.setState({
      selectedPhoto: obj,
      currNum: parseInt(id,10)
    })
  }
  handleClick = (e) => {
    e.preventDefault();
    let id = e.currentTarget.href.substr(e.currentTarget.href.length - 4);
    this.selectPhoto(id);
    this.setState({
      viewPhoto: true
    })
  }
  handleImageLoaded = (e) => {
    e.currentTarget.classList.add('loaded');
  }
  render(){

    return(
      <div className="general-content photos-content">
        {this.state.viewPhoto && 
          <PhotoModal
            photos={this.props.photos}
            view={this.state.viewPhoto}
            photo={this.state.selectedPhoto}
            handleClose={this.handleClose}
            nextPhoto={this.nextPhoto}
            prevPhoto={this.prevPhoto}
            currNum={this.state.currNum}
          />
        }
        <h2 className="content-headline no-margin">Photos</h2>
        
        <div className="row images">
          { this.props.photos.map((val, idx) => (

          <div key={idx} className={`medium-6 columns img-wrapper ${idx === this.props.photos.length -1 && 'end'}`}>
            <a onClick={this.handleClick} href={`${ROOT_DIR}/assets/img/photos/${val.id}`}>

              <LazyLoad height={250} offset={[-200, 0]} placeholder={<Placeholder/>}>
                <img 
                  className="photo" 
                  src={`assets/img/photos/photo${val.id}_th.jpg`}
                  onLoad={this.handleImageLoaded}
                  />
              </LazyLoad>
            </a>
          </div>

          ))}

          
        </div>
        

      </div>
    );
  }
}
export default Photos;


// WEBPACK FOOTER //
// ./src/modules/pages/Photos.js